import type {PaginationNextTriggerProps, PaginationPrevTriggerProps} from '@ark-ui/react/pagination';
import {faArrowLeft} from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import {faArrowRight} from '@fortawesome/pro-light-svg-icons/faArrowRight';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Button} from '../Button/Button';
import {Skeleton} from '..';

import {SKELETON_HEIGHT} from './Pagination';
import {useStyles} from './context';

import {
  PaginationNextTrigger as ArkNextTrigger,
  PaginationPrevTrigger as ArkPrevTrigger,
  usePaginationContext,
} from '@ark-ui/react/pagination';

type NextTriggerProps = PaginationNextTriggerProps & {
  isLoaded?: boolean;
};

export const PaginationNextTrigger = (props: NextTriggerProps) => {
  const {trigger} = useStyles();
  const {isLoaded, ...rest} = props;
  const {nextPage} = usePaginationContext();
  return (
    <Skeleton height={SKELETON_HEIGHT} isLoaded={isLoaded}>
      <ArkNextTrigger asChild>
        <Button
          size={`xs`}
          variant={`subtle`}
          rightIcon={<FontAwesomeIcon icon={faArrowRight} />}
          isDisabled={!nextPage}
          sx={trigger}
          {...rest}>
          Next
        </Button>
      </ArkNextTrigger>
    </Skeleton>
  );
};

type PrevTriggerProps = PaginationPrevTriggerProps & {
  isLoaded?: boolean;
};

export const PaginationPrevTrigger = (props: PrevTriggerProps) => {
  const {trigger} = useStyles();
  const {isLoaded, ...rest} = props;
  const {previousPage} = usePaginationContext();
  return (
    <Skeleton height={SKELETON_HEIGHT} isLoaded={isLoaded}>
      <ArkPrevTrigger asChild>
        <Button
          size={`xs`}
          variant={`subtle`}
          isDisabled={!previousPage}
          leftIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          sx={trigger}
          {...rest}>
          Prev
        </Button>
      </ArkPrevTrigger>
    </Skeleton>
  );
};
